"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignalStrength = SignalStrength;
var _react = _interopRequireDefault(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SignalStrength = require("./SignalStrength.styled");
var _SignalIcon = _interopRequireDefault(require("./SignalIcon"));
var tooltipTextMap = {
  poor: 'Poor connection',
  good: 'Good connection',
  excellent: 'Excellent connection'
};
function SignalStrength(_ref) {
  var attendeeId = _ref.attendeeId,
    networkQuality = _ref.networkQuality,
    latency = _ref.latency,
    packetLoss = _ref.packetLoss,
    jitter = _ref.jitter,
    videoSent = _ref.videoSent,
    videoReceived = _ref.videoReceived,
    _ref$showTextLabel = _ref.showTextLabel,
    showTextLabel = _ref$showTextLabel === void 0 ? false : _ref$showTextLabel,
    _ref$isLightTheme = _ref.isLightTheme,
    isLightTheme = _ref$isLightTheme === void 0 ? false : _ref$isLightTheme,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? null : _ref$width,
    mode = _ref.mode;
  var health = networkQuality;
  var toolTipId = "network-info-".concat(attendeeId);
  var tooltipText = tooltipTextMap[health] || 'No network data';
  var inlineTooltipText = tooltipText;
  if (width && width <= 1068) {
    inlineTooltipText = inlineTooltipText.replace('connection', '').trim();
  }
  return /*#__PURE__*/_react["default"].createElement(_SignalStrength.IconsWrapper, null, /*#__PURE__*/_react["default"].createElement(_SignalStrength.IconTextWrapper, null, /*#__PURE__*/_react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: health,
    isLightTheme: isLightTheme,
    attendeeId: attendeeId
  }), showTextLabel && /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkLabel, null, inlineTooltipText)), /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledToolTip, {
    delay: {
      show: 300,
      hide: 100
    },
    id: "tooltip_".concat(toolTipId),
    target: toolTipId,
    placement: 'top',
    modifiers: [{
      name: 'preventOverflow',
      options: {
        boundary: 'window'
      }
    }],
    mode: mode
  }, health === 'NA' && /*#__PURE__*/_react["default"].createElement(_SignalStrength.TooltipContent, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: health,
    tooltipShown: true
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, tooltipText))), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NoConnectivityMetricsMsg, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, "Turn on the camera to view network details."))), health !== 'NA' && /*#__PURE__*/_react["default"].createElement(_SignalStrength.TooltipContent, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: health,
    tooltipShown: true
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, tooltipText)), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faLinkSlash
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Packet Loss:"), " ", packetLoss, "%")), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faWaveSquare
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Jitter:"), " ", jitter, "ms")), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faStopwatch
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Latency:"), " ", latency, "ms")), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _proSolidSvgIcons.faVideoArrowUpRight
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Sending:"), " ", videoSent)), videoReceived && videoReceived !== 'NA' && /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _proSolidSvgIcons.faVideoArrowDownLeft
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Receiving:"), " ", videoReceived)))));
}
SignalStrength.propTypes = {
  attendeeId: _propTypes["default"].string.isRequired,
  networkQuality: _propTypes["default"].string,
  latency: _propTypes["default"].string,
  packetLoss: _propTypes["default"].string,
  jitter: _propTypes["default"].string,
  videoSent: _propTypes["default"].string,
  videoReceived: _propTypes["default"].string,
  showTextLabel: _propTypes["default"].bool,
  mode: _propTypes["default"].string,
  isLightTheme: _propTypes["default"].bool,
  width: _propTypes["default"].any
};